module.exports = __webpack_public_path__ + "img/P150T_weapon_101.17be2b1b.png";